import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import TableHead from "@material-ui/core/TableHead"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import {formatNumberWithCommas, timeFormatter2} from "../../fncomponents/UISupportFns"

const useStyles1 = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5),
    },
}))

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, columns } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map(column => (
                    <TableCell
                        key={column.id}
                        align={column.numeric ? 'right' : 'left'}
                        padding={'default'}
                        sortDirection={orderBy === column.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === column.id}
                            direction={order}
                            onClick={createSortHandler(column.id)}
                        >
                            {column.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
}

function TablePaginationActions(props) {
    const classes = useStyles1()
    const theme = useTheme()
    const { count, page, rowsPerPage, onChangePage } = props

    function handleFirstPageButtonClick(event) {
        onChangePage(event, 0)
    }

    function handleBackButtonClick(event) {
        onChangePage(event, page - 1)
    }

    function handleNextButtonClick(event) {
        onChangePage(event, page + 1)
    }

    function handleLastPageButtonClick(event) {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    )
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
}

const useStyles2 = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}))

const userStatuses = {
    1: "Pending...",
    2: "Active",
    66: "Deactivated",
}

export default function MyInvestmentPurchsesTable(props) {
    const classes = useStyles2()
    const {rows, rowsPerPage, setRowsPerPage, page, setPage, totalDocs,
        history, changeTabToPrograms} = props
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('value')


    function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === 'desc'
        setOrder(isDesc ? 'asc' : 'desc')
        setOrderBy(property)
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalDocs - page * rowsPerPage)

    function handleChangePage(event, newPage) {
        setPage(newPage)
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }
    return (
        <Paper className={classes.root}>
            <div className={classes.tableWrapper}>
                <Table className={classes.table}>
                    <TableBody>
                        <TableRow hover tabIndex={-1} key={"filterRow"}>
                            <TableCell component="th" scope="row">
                                <div style={{fontSize:"1rem", opacity: "0.7", marginTop: "1rem"}}>Date</div>
                            </TableCell>
                            <TableCell component="th" scope="row">
                                Project
                            </TableCell>
                            <TableCell component="th" scope="row">
                                Amount
                            </TableCell>
                            <TableCell component="th" scope="row">
                                Tokens
                            </TableCell>
                        </TableRow>
                        {rows && rows.map(row => (
                            <TableRow hover tabIndex={0} key={row._id}>
                                <TableCell component="th" scope="row">
                                    {timeFormatter2(row.creationDate, true)}
                                </TableCell>
                                <TableCell>
                                    <span className={"linkButton"}
                                          style={{fontWeight: "normal", fontSize: "0.9rem"}}
                                          onClick={() => {changeTabToPrograms(); history.push(`/contributions?id=${row.investmentProgram._id}`)}}>
                                        {row.investmentProgram ? row.investmentProgram.title: row.investmentProgram}
                                    </span>
                                </TableCell>
                                <TableCell>
                                    {formatNumberWithCommas(row.amount)} {row.coin}
                                </TableCell>
                                <TableCell>
                                    {row.tokens === 0 && <div>Tokens calculated after sale ends</div>}
                                    {row.tokens > 0 && <div>{formatNumberWithCommas(row.tokens)} {row.investmentProgram ? row.investmentProgram.token: ""}</div>}
                                    {row.tokensStatus === 1 &&
                                    <div>
                                        <div style={{color: "#f7a102", fontSize: "0.8rem"}}>Locked</div>
                                    </div>}
                                    {row.tokensStatus === 2 &&
                                    <div>
                                        <div style={{color: "#17bebb", fontSize: "0.8rem"}}>Partially unlocked</div>
                                    </div>}
                                    {row.tokensStatus === 3 &&
                                    <div>
                                        <div style={{color: "#64fe7c", fontSize: "0.8rem"}}>Unlocked</div>
                                    </div>}
                                    {row.tokensStatus === 2 && <div><span style={{opacity: "0.7"}}>unlocked</span> {formatNumberWithCommas(row.distributedTokens)} {row.investmentProgram ? row.investmentProgram.token: ""}</div>}
                                    {row.investmentProgram.whenUnlock && <div style={{fontSize: "0.7rem", opacity: "0.8"}}>{row.investmentProgram.whenUnlock}</div>}
                                </TableCell>
                            </TableRow>
                        ))}
                        {(!rows || rows && rows.length === 0) && (
                            <TableRow style={{ height: 48 * emptyRows }}>
                                <TableCell colSpan={4}>
                                    <div style={{textAlign: "center"}}>You have no purchases yet</div>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </Paper>
    )
}
